import React, { useState } from "react";
import MenuBar from "./Menu/MenuBar.js";
import Headline from "./Headline.js";
import WeatherForecast from "./WeatherForecast.js";
import SubSection from "./SubSection.js";
import Footer from "./Footer.js";

const App: React.FC = () => {
  return (
    <div className="background-image relative min-h-screen bg-fixed">
      <MenuBar className="bg-nearblack-500 text-white" />

      <div className="px-4 pt-16 sm:px-24">
        <Headline className="text-white" />

        <WeatherForecast />

        {/* <SubSection className="text-white" /> */}

        <div className="container mx-auto py-8">
          <Footer className="mt-12 text-center text-sm text-gray-500" />
        </div>
      </div>
    </div>
  );
};

export default App;
